import { defineMessages } from "react-intl";

const messages = defineMessages({
  unsubscribeButtonLabel: {
    id: "emailUnsubscribe.unsubscribedButtonLabel",
    defaultMessage: "Unsubscribe Now",
    description: "Email unsubscribe button label",
  },
  unsubscribedText: {
    id: "emailUnsubscribe.unsubscribedText",
    defaultMessage: "You have been successfully unsubscribed.",
    description: "Email unsubscribe text",
  },
  unsubscribeText: {
    id: "emailUnsubscribe.unsubscribeText",
    defaultMessage:
      "Are you sure you wish to unsubscribe from further commercial emails from {name}?",
    description: "Email unsubscribed text",
  },
});

export default messages;
